import { useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { tipoOrigenTrabajadorApi } from '../api/tipoOrigenTrabajadorApi';

export const useTipoOrigenTrabajadores = () => {
  const [tiposOrigen, setTiposOrigen] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Obtener todos los tipos de origen
  const fetchTiposOrigen = useCallback(async () => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await tipoOrigenTrabajadorApi.getAll();
      setTiposOrigen(data);
      return data;
    } catch (error) {
      const errorMessage = error.response?.data?.detail || 'Error al obtener tipos de origen';
      setError(errorMessage);
      toast.error(errorMessage);
      throw error;
    } finally {
      setLoading(false);
    }
  }, []);

  // Obtener tipo de origen por ID
  const fetchTipoOrigenById = useCallback(async (id) => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await tipoOrigenTrabajadorApi.getById(id);
      return data;
    } catch (error) {
      const errorMessage = error.response?.data?.detail || 'Error al obtener tipo de origen';
      setError(errorMessage);
      toast.error(errorMessage);
      throw error;
    } finally {
      setLoading(false);
    }
  }, []);

  // Crear tipo de origen
  const createTipoOrigen = useCallback(async (tipoOrigenData) => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await tipoOrigenTrabajadorApi.create(tipoOrigenData);
      setTiposOrigen(prev => [...prev, data]);
      toast.success('Tipo de origen creado exitosamente');
      return data;
    } catch (error) {
      const errorMessage = error.response?.data?.detail || 'Error al crear tipo de origen';
      setError(errorMessage);
      toast.error(errorMessage);
      throw error;
    } finally {
      setLoading(false);
    }
  }, []);

  // Actualizar tipo de origen
  const updateTipoOrigen = useCallback(async (id, tipoOrigenData) => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await tipoOrigenTrabajadorApi.update(id, tipoOrigenData);
      setTiposOrigen(prev => 
        prev.map(tipo => 
          tipo.id === id ? data : tipo
        )
      );
      toast.success('Tipo de origen actualizado exitosamente');
      return data;
    } catch (error) {
      const errorMessage = error.response?.data?.detail || 'Error al actualizar tipo de origen';
      setError(errorMessage);
      toast.error(errorMessage);
      throw error;
    } finally {
      setLoading(false);
    }
  }, []);

  // Eliminar tipo de origen
  const deleteTipoOrigen = useCallback(async (id) => {
    setLoading(true);
    setError(null);
    
    try {
      await tipoOrigenTrabajadorApi.delete(id);
      setTiposOrigen(prev => prev.filter(tipo => tipo.id !== id));
      toast.success('Tipo de origen eliminado exitosamente');
      return true;
    } catch (error) {
      const errorMessage = error.response?.data?.detail || 'Error al eliminar tipo de origen';
      setError(errorMessage);
      toast.error(errorMessage);
      throw error;
    } finally {
      setLoading(false);
    }
  }, []);

  // Limpiar error
  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    // Estado
    tiposOrigen,
    loading,
    error,
    
    // Acciones
    fetchTiposOrigen,
    fetchTipoOrigenById,
    createTipoOrigen,
    updateTipoOrigen,
    deleteTipoOrigen,
    clearError,
  };
};

